import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorRepayment = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#F7A600"
      fillRule="evenodd"
      d="M13.543 11.482a.75.75 0 0 1-.025 1.06l-2.836 2.708H21a.75.75 0 0 1 0 1.5H8.81a.75.75 0 0 1-.518-1.293l4.19-4a.75.75 0 0 1 1.06.025Z"
      clipRule="evenodd"
    />
    <path
      fill={getTheme(props["data-theme"])}
      fillRule="evenodd"
      d="M2.25 6A2.75 2.75 0 0 1 5 3.25h14A2.75 2.75 0 0 1 21.75 6v5a.75.75 0 0 1-1.5 0V6c0-.69-.56-1.25-1.25-1.25H5c-.69 0-1.25.56-1.25 1.25v12c0 .69.56 1.25 1.25 1.25h16a.75.75 0 0 1 0 1.5H5A2.75 2.75 0 0 1 2.25 18V6Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgTwoColorRepayment;
